import { PersistentStore } from './main';
import { ITimelineEntry, ITimeline, TimelineStoreInterface } from '@/models/timeline.model';
import { RepositoryFactory } from '@/api/repositoryFactory';
import { IPagerResponse } from '@/models/pager.model';
import moment from 'moment';
const timelineRepository = RepositoryFactory.get('timeline');
class TimelineStore extends PersistentStore<TimelineStoreInterface> {
  protected data(): TimelineStoreInterface {
    return {
      timeline: {
        archived: 0,
        created: '',
        domainid: 0,
        id: 0,
        order_by: undefined,
        public: 0,
        title: '',
        show_month: 0,
      },
      entries: [],
      pager: {
        current_page: 0,
        entries_per_page: 0,
        total_entries: 0,
      },
      isLoadingContent: false,
      closestIndex: -1,
    };
  }
  setIsLoadingContent(value: boolean) {
    this.state.isLoadingContent = value;
  }
  setTimeline(timeline: ITimeline) {
    this.state.timeline = timeline;
  }
  setTimelineid(timelineid: number) {
    this.state.timeline.id = timelineid;
    this.getTimeline(timelineid);
  }
  private sortEntries(entries: ITimelineEntry[]) {
    const today = moment().format('YYYY-MM-DD');
    const reversedEntries = entries.slice().reverse(); // reverse copy of array
    const entriesDate = reversedEntries.map(value => {
      if (today >= value.start) {
        return Math.abs(Date.parse(today) - Date.parse(value.start));
      } else {
        return Math.abs(Date.parse(value.start) - Date.parse(today));
      }
    });
    console.log(reversedEntries);
    console.log(entriesDate);
    const minimum = Math.min(...entriesDate);
    console.log(minimum);
    const foundIndex = entriesDate.indexOf(minimum);
    console.log(foundIndex);
    this.state.closestIndex = foundIndex > 1 ? foundIndex - 1 : 0;
    console.log(this.state.closestIndex);
  }
  private setEntries(entries: ITimelineEntry[]) {
    this.state.entries = entries;
    if (this.state.timeline.order_by == 'start') {
      this.sortEntries(entries);
    }
  }
  private setAddetionalEntries(entries: ITimelineEntry[]) {
    entries.forEach(element => {
      this.state.entries.push(element);
    });
  }
  setPager(pager: IPagerResponse) {
    this.state.pager = pager;
  }
  fetchEntries(timelineid: number, order_by: string) {
    timelineRepository.getTimelineEntries(timelineid, { sort: order_by, page: 1 }).then((res: any) => {
      this.setEntries(res.data.data);
      this.setPager(res.data.pager);
    });
  }
  fetchAddetionalEntries() {
    this.setIsLoadingContent(true);
    timelineRepository
      .getTimelineEntries(this.state.timeline.id, {
        sort: this.state.timeline.order_by,
        page: this.state.pager.current_page + 1,
      })
      .then((res: any) => {
        this.setAddetionalEntries(res.data.data);
        this.setPager(res.data.pager);
      })
      .finally(() => {
        this.setIsLoadingContent(false);
      });
  }
  getTimeline(timelineid: number) {
    timelineRepository.getTimeline(timelineid).then((res: any) => {
      this.setTimeline(res.data.data);
      this.fetchEntries(timelineid, res.data.data.order_by);
    });
  }
}

export const timelineStore: TimelineStore = new TimelineStore('TIMELINE_STORE');
